// extracted by mini-css-extract-plugin
export default {"label":"MultipleChoice_label__PEJrt","subtitle":"MultipleChoice_subtitle__E1kDa","number":"MultipleChoice_number__Hq0fk"};